export const authConfige = {
  "X-Api-Key": "du7lik773nspohl0",
  AUTHORIZATION: `Bearer ${localStorage.token}`,
  "Content-Type": "application/json",
};
